import { render, staticRenderFns } from "./component-bc463569.vue?vue&type=template&id=03c4d0ca&scoped=true&"
import script from "./component-bc463569.vue?vue&type=script&lang=js&"
export * from "./component-bc463569.vue?vue&type=script&lang=js&"
import style0 from "./component-bc463569.vue?vue&type=style&index=0&id=03c4d0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c4d0ca",
  null
  
)

export default component.exports